import { computed } from "@ember/object";
import { classNameBindings, classNames } from "@ember-decorators/component";
import { resolveComponent } from "discourse/select-kit/components/select-kit";
import SingleSelectHeaderComponent from "discourse/select-kit/components/select-kit/single-select-header";
import dIcon from "discourse/ui-kit/helpers/d-icon";

@classNames("dropdown-select-box-header")
@classNameBindings("btnClassName", "btnStyleClass", "btnCustomClasses")
export default class DropdownSelectBoxHeader extends SingleSelectHeaderComponent {
  @computed("selectKit.options.showFullTitle")
  get showFullTitle() {
    return this.selectKit?.options?.showFullTitle;
  }

  @computed("selectKit.options.customStyle")
  get customStyle() {
    return this.selectKit?.options?.customStyle;
  }

  @computed("selectKit.options.btnCustomClasses")
  get btnCustomClasses() {
    return this.selectKit?.options?.btnCustomClasses;
  }

  @computed("selectKit.options.caretUpIcon")
  get caretUpIcon() {
    return this.selectKit?.options?.caretUpIcon;
  }

  @computed("selectKit.options.caretDownIcon")
  get caretDownIcon() {
    return this.selectKit?.options?.caretDownIcon;
  }

  @computed("showFullTitle")
  get btnClassName() {
    return `btn ${this.showFullTitle ? "btn-icon-text" : "no-text btn-icon"}`;
  }

  @computed("customStyle")
  get btnStyleClass() {
    return `${this.customStyle ? "" : "btn-default"}`;
  }

  @computed("selectKit.isExpanded", "caretUpIcon", "caretDownIcon")
  get caretIcon() {
    return this.selectKit.isExpanded ? this.caretUpIcon : this.caretDownIcon;
  }

  <template>
    <div class="select-kit-header-wrapper">
      {{#each this.icons as |iconName|}} {{dIcon iconName}} {{/each}}

      {{#let
        (resolveComponent this this.selectKit.options.selectedNameComponent)
        as |SelectedNameComponent|
      }}
        <SelectedNameComponent
          @tabindex={{this.tabindex}}
          @item={{this.selectedContent}}
          @selectKit={{this.selectKit}}
          @shouldDisplayClearableButton={{this.shouldDisplayClearableButton}}
        />
      {{/let}}

      {{#if this.selectKit.options.showCaret}}
        {{dIcon this.caretIcon class="angle-icon"}}
      {{/if}}
      &#8203;
      {{! Zero-width space character, so icon-only button height = regular button height }}
    </div>
  </template>
}
